import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_DELIVERIES,
  CLEAR_DELIVERY,
  FLAG_DELIVERY_ACTIVITY,
  FLAG_GETTING_DELIVERIES,
  GET_DELIVERIES,
  GET_DELIVERY,
  OPEN_MODAL,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
  modal: false,
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_DELIVERIES:
      return state.setIn(['all', 'loading'], payload);
    case GET_DELIVERIES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_DELIVERIES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_DELIVERY_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_DELIVERY:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_DELIVERY:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case OPEN_MODAL:
      return state.set('modal', payload);
    default:
      return state;
  }
};
